import { Component, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CrudOrgComponent } from '../crud-organisation/crud-org.component';
import { ButtonModule } from 'primeng/button'; // Import ButtonModule
import { CommonModule } from '@angular/common'; // Import CommonModule for *ngIf
import { CrudOrgPermissionsComponent } from '../crud-org-permissions/crud-org-permissions.component';
import { DialogModule } from 'primeng/dialog'; // Import DialogModule
import { CrudUserComponent } from '../crud-user/crud-user.component'; // Import CrudUserComponent
import { CrudOrgInvitesComponent } from '../crud-org-invites/crud-org-invites.component'; // Import CrudOrgInvitesComponent
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-manage-org',
    templateUrl: './manage-org.component.html',
    styleUrls: ['./manage-org.component.css'],
    imports: [CommonModule, CrudOrgComponent, ButtonModule, CrudOrgPermissionsComponent, DialogModule, CrudUserComponent, CrudOrgPermissionsComponent, CrudOrgInvitesComponent, TranslateModule]
})
export class ManageOrgComponent {
  @ViewChild(CrudOrgComponent) orgComponent!: CrudOrgComponent;
  orgId: string | null = null;
  mode: 'read' | 'update' = 'read'; // Add mode property
  permissionsMode: 'read' | 'update' = 'read';
  showAddUserDialog = false; // Add property to control dialog visibility

  constructor(private route: ActivatedRoute) {
    this.orgId = this.route.snapshot.paramMap.get('orgId');
  }

  enableEditMode() {
    this.mode = 'update';
    /* when we update we want to reset the crud org component to first page */
    this.orgComponent.page = 1;
  }

  onCancel() {
    this.mode = 'read';
  }

  onUpdateSuccess() {
    this.mode = 'read';
  }

  onCreateSuccess() {
    this.showAddUserDialog = false; // Close the dialog on successful creation
    this.permissionsMode = 'read';
  }

  enablePermissionsEditMode() {
    this.permissionsMode = 'update';
  }

  cancelPermissionsEditMode() {
    this.permissionsMode = 'read';
  }

  openAddUserDialog() {
    this.showAddUserDialog = true;
  }

  closeAddUserDialog() {
    this.showAddUserDialog = false;
    // Optionally refresh permissions list here if needed after adding a user
  }
}
